import { FC } from 'react';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import styles from './AvisoUpgradeConfirmacao.module.scss';

import LogoUpgradeConfirmacao from 'Static/images/logo-upgrade-confirmacao.png';

interface IAvisoUpgradeConfirmacao {
  visible?: boolean;
  onConfirm?: () => void;
}

const AvisoUpgradeConfirmacao: FC<IAvisoUpgradeConfirmacao> = ({ visible, onConfirm }) => {
  const buttons = (
    <div>
      <Button className={styles['button']} type='primary' height={37} onClick={onConfirm}>
        Ok
      </Button>
    </div>
  );

  return (
    <Modal
      footerButtons={buttons}
      visible={visible}
      width={650}>
      <div className={styles['wrapper']}>
        <img
          alt="Logo Upgrade Confirmacao"
          src={LogoUpgradeConfirmacao}
          className={styles['imageWrapper']}
        />
        <div className={styles['contentWrapper']}>
          <label className={styles['avisoConfirmacaoEnvio']}>
            Tudo certo!
          </label>
          <h2>Em breve nosso time entrará em contato para auxiliá-lo no upgrade da sua conta</h2>
        </div>
      </div>
    </Modal>
  );
};

export default AvisoUpgradeConfirmacao;
